import { useCallback, useState } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';

import useQuiz from '../../../hooks/useQuiz';
import questionService from '../../../services/useCases/Question';
import { formatError, snackbarUtils } from '../../../utils';

import NoQuiz from './NoQuiz';
import BlueButton from '../../../components/BlueButton';
import Backdrop from '../../../components/Backdrop';
import { ArrowForwardIcon } from '../../../assets/icons';
import useStyles from './styles';

interface Props {
  goToStart: () => void;
  goToEnd: () => void;
}

const Questions = ({ goToStart, goToEnd }: Props) => {
  const classes = useStyles();
  const { questions, currentQuestion, setCurrentQuestion, handleQuestion, isSuspect, isDisabled, loading, lastQuestion } = useQuiz();

  const [isSubmitting, setIsSubmitting] = useState(false);
  // console.log('isSuspect: ', isSuspect);

  const goBack = useCallback(() => {
    if (currentQuestion === 0) goToStart();
    else setCurrentQuestion(value => value - 1);
  }, [currentQuestion, goToStart, setCurrentQuestion]);

  const goForward = useCallback(async () => {
    if (lastQuestion) {
      setIsSubmitting(true);
      try {
        const IsSuspectResponse = isSuspect.some(item => item);
        await questionService.sendQuiz(questions, IsSuspectResponse);
        goToEnd();
        // console.log(questions);
        // console.log('isSuspect: ', isSuspect);
      } catch (error) {
        console.error(error.message);
        snackbarUtils.error(formatError(error));
      } finally {
        setIsSubmitting(false);
      }
    }
    else setCurrentQuestion(value => value + 1);
  }, [lastQuestion, questions, isSuspect, setCurrentQuestion, goToEnd])

  if (loading) return <Typography>Carregando...</Typography>
  if (questions.length === 0) return <NoQuiz />
  const question = questions[currentQuestion];

  return (
    <Grid container item xs={12} spacing={3} className={classes.container}>
      <Backdrop loading={isSubmitting} />
      <Typography variant="h2">{question.title}</Typography>

      <Grid container item xs={12} spacing={1} className={classes.questionsContainer}>
        {question.answers.map((answer, index) => (
          <Grid key={answer.id} container item xs={4} sm={3} xl={2} justify="center">
            <Button
              data-cy={`quiz-answer-${index}`}
              variant="outlined"
              onClick={() => handleQuestion(index)}
              className={clsx({
                [classes.questionButton]: true,
                [classes.activeQuestion]: answer.answer,
              })}
            >
              {answer.title}
            </Button>
          </Grid>
        ))}
      </Grid>
      <Container maxWidth="sm">
        <Grid container item xs={12} spacing={3} className={classes.buttonsContainer}>
          <Grid container item xs={6} justify="center">
            <Button variant="outlined" onClick={goBack} className={classes.backButton}>
              Voltar
            </Button>
          </Grid>
          <Grid container item xs={6} justify="center">
            <BlueButton
              dataCy="quiz-go-forward-button"
              endIcon={<ArrowForwardIcon />}
              action={goForward}
              disabled={isDisabled[currentQuestion]}
              className={classes.forwardButton}
            >
              {!lastQuestion ? 'Próxima' : 'Finalizar'}
            </BlueButton>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

export default Questions;